export default "__VITE_ASSET__exx6VI5K__"